module.exports = __webpack_public_path__ + "static/media/banner-angalong.f6b36ebe.jpg";